import axios from 'axios';
import querystring from 'querystring';
import Swal from 'sweetalert2';
import { translator } from './Translator';
import { getCompanyConfig } from './CompanyConfig';

//Company Config Key ของลิงก์หน้าเปลี่ยนรหัสผ่าน
export const FORGOT_PASSWORD_CONFIG_KEY = "FORGOT_PASSWORD_URL";

//ระยะเวลาตรวจสอบรหัสผ่านหมดอายุซ้ำ กรณีเปิดหน้าค้างไว้โดยไม่เปลี่ยนหน้า (5 นาที)
export const PASSWORD_EXPIRE_CHECK_INTERVAL = 5 * 60 * 1000;

/**
 * ดึงลิงก์หน้าเปลี่ยนรหัสผ่านจาก Company Config
 * ส่ง accessToken เข้ามาได้กรณียังไม่มี token ใน localStorage
 * คืนค่าว่างถ้ายังไม่ได้ตั้งค่า Config Key นี้ให้บริษัทนั้น (popup จะไม่แสดงลิงก์)
 */
export const getForgotPasswordUrl = async (company, accessToken) => {
    const configValue = await getCompanyConfig(
        company,
        FORGOT_PASSWORD_CONFIG_KEY,
        "",
        { accessToken }
    );

    if (!configValue)
        console.warn(`Company Config "${FORGOT_PASSWORD_CONFIG_KEY}" ยังไม่ได้ตั้งค่าสำหรับ company ${company} - popup จะไม่แสดงลิงก์เปลี่ยนรหัสผ่าน`);

    return configValue || "";
}

/**
 * เรียก API ตรวจสอบวันหมดอายุรหัสผ่าน
 * ส่ง accessToken เข้ามาได้ในกรณีที่ยังไม่ได้เก็บ token ลง localStorage (ตอน login)
 * คืนค่า null เมื่อเรียก API ไม่สำเร็จ เพื่อไม่ให้ผู้ใช้ถูกบล็อกการเข้าใช้งาน
 */
export const checkPasswordExpire = async (company, username, accessToken) => {
    if (!company || !username)
        return null;

    try {
        const queryString = querystring.stringify({ company, username });
        const url = `${process.env.REACT_APP_API_URL}passwordExpire?${queryString}`;

        const token = accessToken || localStorage.getItem('x-access-token');
        const config = token ? { headers: { "Authorization": `Bearer ${token}` } } : {};

        const result = await axios.get(url, config);
        return result.data;
    } catch (error) {
        console.error("checkPasswordExpire", error);
        return null;
    }
}

export const isPasswordExpired = (passwordExpire) => {
    return passwordExpire ? passwordExpire.isExpired === true : false;
}

/**
 * Popup แจ้งเตือนรหัสผ่านหมดอายุ พร้อมลิงก์ไปหน้าเปลี่ยนรหัสผ่านจาก Company Config
 * options.isSignedIn = true สำหรับกรณีที่ถูก clear session ระหว่างใช้งาน
 * options.accessToken สำหรับกรณีที่ยังไม่มี token ใน localStorage
 */
export const showPasswordExpiredAlert = async (company, translate = {}, options = {}) => {
    const { isSignedIn = false, accessToken } = options;

    const forgotPasswordUrl = await getForgotPasswordUrl(company, accessToken);

    const message = isSignedIn
        ? translator(translate.ISA_PasswordExpired_SignedInMessage, "รหัสผ่านของคุณหมดอายุแล้ว ระบบได้ออกจากระบบให้อัตโนมัติ กรุณาเปลี่ยนรหัสผ่านก่อนเข้าสู่ระบบอีกครั้ง")
        : translator(translate.ISA_PasswordExpired_Message, "รหัสผ่านของคุณหมดอายุแล้ว กรุณาเปลี่ยนรหัสผ่านก่อนเข้าสู่ระบบ");

    //แสดงลิงก์เฉพาะเมื่อมีค่าใน Company Config
    const linkHtml = forgotPasswordUrl
        ? `<a href="${forgotPasswordUrl}" target="_blank" rel="noopener noreferrer">`
            + `${translator(translate.ISA_PasswordExpired_ResetLink, "คลิกที่นี่เพื่อเปลี่ยนรหัสผ่าน")}`
            + `</a>`
        : "";

    return Swal.fire({
        icon: "warning",
        title: translator(translate.ISA_PasswordExpired_Title, "รหัสผ่านหมดอายุ"),
        html: `<div class="mb-3">${message}</div>` + linkHtml,
        confirmButtonText: translator(translate.ISA_OK, "OK"),
    });
}
